import React, { useState, useCallback, useEffect } from 'react';
import { ReactSortable } from 'react-sortablejs';
import {
  DisplayText,
  TextStyle,
  Heading,
  ResourceItem,
  Checkbox
} from '@superops/ui-design-system';
import { FormattedMessage, useIntl } from 'react-intl';
import ReorderIcon from '@nile/banyan/public/svg/ic_reorder.svg';
import {
  AutoCompleteSearchInput,
  getHighlightedText,
  getTranslatedText
} from '@nile/components';

const ViewTableColumns = (props) => {
  const {
    columns,
    tableColumnsFields,
    setTableColumnsFields,
    selectedColumns,
    availableColumns,
    module
  } = props;

  const intl = useIntl();

  const [allColumns, setAllColumns] = useState(columns || []);
  const [availableFields, setAvailableFields] = useState([]);
  const [filterExpression, setFilterExpression] = useState('');

  useEffect(() => {
    columns && setAllColumns(columns);
    setTableColumnsFields(columns.filter((item) => item.selected) || []);
  }, [columns]);

  useEffect(() => {
    if (allColumns) {
      let selected = allColumns.filter((item) => item.selected);
      let available = allColumns.filter((item) => !item.selected);
      // Ensure available fields follow the original order in `columns`
      available.sort(
        (a, b) =>
          columns.findIndex((col) => col.id === a.id) -
          columns.findIndex((col) => col.id === b.id)
      );

      setAvailableFields(available || []);
    }
  }, [allColumns, columns]);

  const debouncedFilter = useCallback((value) => {
    setFilterExpression(value.toLowerCase());
  }, []);

  const handleSelectedItems = (id) => {
    setAllColumns((prev) => {
      // Find the item to toggle
      const itemToToggle = prev.find((item) => item.id === id);
      if (!itemToToggle) return prev;

      if (!itemToToggle.selected) {
        // If selecting, move item to the end of the selected list
        return [
          ...prev.filter((item) => item.id !== id), // Remove from current list
          { ...itemToToggle, selected: true } // Add at the end
        ];
      } else {
        return prev.map((item) =>
          item.id === id ? { ...item, selected: false } : item
        );
      }
    });
    setTableColumnsFields((prev) => {
      const itemExists = prev.some((item) => item.id === id);
      if (itemExists) {
        return prev.filter((item) => item.id !== id); // Remove item if it exists
      } else {
        const itemToToggle = allColumns.find((item) => item.id === id);
        return itemToToggle
          ? [...prev, { ...itemToToggle, selected: true }]
          : prev; // Add item if not found
      }
    });
  };
  const renderSelectedFields = (item) => {
    return (
      <div>
        <TextStyle>
          <span
            className="dragHandle mr8 cursor-move"
            style={{ opacity: '0.5' }}
          >
            <ReorderIcon />
          </span>
          <Checkbox
            label={item.label}
            id={item.id}
            name={item.id}
            checked
            disabled={item.disable}
            onChange={() => {
              handleSelectedItems(item.id);
            }}
          />
        </TextStyle>
      </div>
    );
  };

  const renderAvailableFields = () => {
    let unselectedFilter = [];
    unselectedFilter = availableFields?.filter((item) => {
      if (filterExpression) {
        return (
          item.label && item.label.toLowerCase().indexOf(filterExpression) > -1
        );
      }
      return item;
    });
    if (unselectedFilter?.length > 0) {
      return unselectedFilter?.map((item) => {
        return (
          <div className="fx g10" key={item.id}>
            <Checkbox
              label={
                <TextStyle>
                  {getHighlightedText(item.label, filterExpression)}
                </TextStyle>
              }
              id={item.id}
              name={item.id}
              onChange={() => {
                handleSelectedItems(item.id);
              }}
            />
          </div>
        );
      });
    } else {
      return (
        <span>
          <FormattedMessage id="admin.Technicianrole.associate.nodata" />
        </span>
      );
    }
  };

  return (
    <>
      <DisplayText element="h2" weight="Bold">
        {/* <FormattedMessage id="taskView.availableColumns" /> */}
        {/* TODO - add lokalise */}
        Choose table column
      </DisplayText>
      <div className="fx p4 border-gray mt-20">
        <div className="p20 border-right-gray">
          <Heading element="h3" weight="Bold">
            {getTranslatedText(intl, 'ticket.columns.select') ||
              'Selected items'}
          </Heading>
          <ReactSortable
            className="sort-wrapper mt20 fx col g20"
            list={tableColumnsFields}
            handle=".dragHandle"
            setList={(li) => {
              setTableColumnsFields(li);
            }}
            animation={200}
          >
            {tableColumnsFields?.map((item) => {
              return <div key={item.id}>{renderSelectedFields(item)}</div>;
            })}
          </ReactSortable>
        </div>
        <div className="p2040">
          <Heading element="h3" weight="Bold">
            {getTranslatedText(intl, 'ticket.columns.fields')}
          </Heading>
          <div className="fw">
            <AutoCompleteSearchInput debouncedFilter={debouncedFilter} />
          </div>
          <div className="fx col g20">{renderAvailableFields()}</div>
        </div>
      </div>
    </>
  );
};

export default ViewTableColumns;
